import './bootstrap';
import './mmenu';
import './teich';
import { onReady } from '@/scripts/ready';
import { onLoad } from '@/scripts/onload';

onReady(() => onLoad());
